import CodeMirror from 'codemirror';
import { matchTokenType } from './utils';
import { IOperatorReplacement } from '../index.d';
import { createSpanReplacementNode } from '../markers/utils';

// 属性路径替换
export function replaceLogicOperator(
    editor: CodeMirror.Editor,
    tokens: CodeMirror.Token[],
    idx: number,
    operatorReplacements: IOperatorReplacement[]) {
    const token = tokens[idx];
    if (matchTokenType(token, 'operator')) {
        const line = token.state.line;
        const operator = operatorReplacements.find(item => item.code === token.string);

        if (operator) {
            const startPos = { line, ch: token.start };
            const endPos = { line, ch: token.end };

            const replaceText = operator.name;

            editor.getDoc().markText(startPos, endPos, {
                replacedWith: createSpanReplacementNode(replaceText, 'cm-operator')
            });

            return 1;
        }
    }
    return 0;
}
